import { string } from 'prop-types'
import React from 'react'

const Location = (props) => {
  if (!props.city) {
    return null
  }
  if (props.city === props.country) {
    return (
      <div className="stats-item location">
        <div className="heading">Location</div>
        <div className="value">
          <span className="city">{props.city}</span>
        </div>
      </div>
    )
  }
  return (
    <div className="stats-item location">
      <div className="heading">Location</div>
      <div className="value">
        <div>
          <span className="city">{props.city}</span>
          {props.stateProvinceAbbreviation &&
            <span className="state-province-abbreviation">, {props.stateProvinceAbbreviation}</span>
          }
        </div>
        {props.country &&
          <div className="country">{props.country}</div>
        }
      </div>
    </div>
  )
}
Location.defaultProps = {
  city: null,
  country: null,
  stateProvinceAbbreviation: null,
}
Location.propTypes = {
  city: string,
  country: string,
  stateProvinceAbbreviation: string,
}

export default Location
